import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import merge from 'lodash/merge';
import set from 'lodash/set';
import some from 'lodash/some';
import Cleave from 'cleave.js/dist/cleave-react';
import FormattedAddress from '../FormattedAddress';
import ModalClientDetails from '../ModalClientDetails';
import AddressForm from '../AddressForm';
import * as analytics from '../../services/analytics';
import './Passport360EnrollmentPolicyholderView.css';

const propTypes = {
  client: PropTypes.object,
  onNotifyError: PropTypes.func,
  onNotifySuccess: PropTypes.func,
  onSubmit: PropTypes.func,
  quote: PropTypes.object,
  updateClient: PropTypes.func,
  updateQuote: PropTypes.func,
};

function ShareLinkDetails({
  editingClient,
  handleNewClientUpdate,
  handlePhoneInit,
  handleInlinePhoneUpdate,
  handleInlineAddressUpdate,
}) {
  return (
    <>
      <div className="Passport360EnrollmentPolicyholderView-clientDetails card m-t-20">
        <div className="card-block form-group row">
          <label className="col-md-3 text-uppercase">
            POLICYHOLDER DETAILS
          </label>
          <div className="col-md-9">
            <div className="form-group">
              <label htmlFor="firstName" className="text-uppercase">
                First name
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="person.first_name"
                value={get(editingClient, 'person.first_name') || ''}
                required
                aria-required="true"
                onChange={handleNewClientUpdate}
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName" className="text-uppercase">
                Last name
              </label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                name="person.last_name"
                value={get(editingClient, 'person.last_name') || ''}
                required
                aria-required="true"
                onChange={handleNewClientUpdate}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email" className="text-uppercase">
                Email
              </label>
              <input
                type="text"
                className="form-control"
                id="email"
                name="person.email"
                value={get(editingClient, 'person.email') || ''}
                required
                aria-required="true"
                onChange={handleNewClientUpdate}
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone" className="text-uppercase">
                Phone
              </label>
              <Cleave
                id="phone"
                className="form-control"
                name="person.phone_number"
                required
                options={{
                  blocks: [3, 3, 4],
                  delimiter: '-',
                  numericOnly: true,
                }}
                value={get(editingClient, 'person.phone_number') || ''}
                onInit={handlePhoneInit}
                onChange={handleInlinePhoneUpdate}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="Passport360EnrollmentPolicyholderView-clientAddress card m-t-20">
        <div className="card-block form-group row">
          <label className="col-md-3 text-uppercase">Home address</label>
          <div className="col-md-9">
            <AddressForm
              address={get(editingClient, 'person.address')}
              onChange={handleInlineAddressUpdate}
            />
          </div>
        </div>
      </div>
    </>
  );
}

function QuoteDetails({
  client,
  editingClient,
  showUpdateClientModal,
  handlePhoneInit,
  handleInlinePhoneUpdate,
  handleInlineAddressUpdate,
}) {
  return (
    <>
      <div className="Passport360EnrollmentPolicyholderView-clientDetails card m-t-20">
        <div className="card-block form-group row">
          <label className="col-md-3 text-uppercase">Client details</label>
          <div className="col-md-7">
            <p>
              <strong>{`${editingClient.person.first_name} ${editingClient.person.last_name}`}</strong>
              <br />
              Email: {editingClient.person.email}
              <br />
              {get(client, 'person.phone_number') && (
                <span>Phone: {client.person.phone_number}</span>
              )}
            </p>
          </div>
          <div className="col-md-2">
            <a
              href="#update-client"
              className="Passport360EnrollmentPolicyholderView-clientDetails-edit text-complete float-right bold"
              onClick={showUpdateClientModal}
            >
              Edit
            </a>
          </div>
        </div>
        {get(client, 'person.address') && (
          <div className="card-block form-group row">
            <label className="col-md-3 semi-bold text-uppercase">
              Mailing address
            </label>
            <div className="col-md-9">
              <FormattedAddress address={editingClient.person.address} />
            </div>
          </div>
        )}
      </div>

      {!get(client, 'person.phone_number') && (
        <div className="Passport360EnrollmentPolicyholderView-clientPhone card m-t-20">
          <div className="card-block form-group row">
            <label className="col-md-3 text-uppercase">Phone number</label>
            <div className="col-md-9">
              <div className="form-group p-t-0">
                <label htmlFor="phoneNumber" className="text-uppercase">
                  Phone
                </label>
                <Cleave
                  id="phone"
                  className="form-control"
                  name="person.phone_number"
                  required
                  options={{
                    blocks: [3, 3, 4],
                    delimiter: '-',
                    numericOnly: true,
                  }}
                  value={get(editingClient, 'person.phone_number') || ''}
                  onInit={handlePhoneInit}
                  onChange={handleInlinePhoneUpdate}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {!get(client, 'person.address') && (
        <div className="Passport360EnrollmentPolicyholderView-clientAddress card m-t-20">
          <div className="card-block form-group row">
            <label className="col-md-3 text-uppercase">Mailing address</label>
            <div className="col-md-9">
              <AddressForm
                address={editingClient.person.address}
                onChange={handleInlineAddressUpdate}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

class Passport360EnrollmentPolicyholderView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingClient: merge({}, props.client),
      isSubmitting: false,
    };
  }

  componentDidMount() {
    const { client, getClient, isShareLinkFlow } = this.props;
    analytics.page('Passport 360 - Enrollment Policyholder');
    !isShareLinkFlow && getClient(client.id);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.client, this.props.client)) {
      this.setState({
        editingClient: merge({}, nextProps.client),
      });
    }
  }

  handlePhoneInit = (cleave) => {
    this.cleave = cleave;
    cleave.setRawValue(get(this.props.client, 'person.phone_number'));
  };

  handleInlinePhoneUpdate = (e) => {
    this.setState({
      editingClient: {
        ...this.state.editingClient,
        person: merge({}, this.state.editingClient.person, {
          phone_number: e.target.value,
        }),
      },
    });
  };

  handleNewClientUpdate = (e) => {
    const editingClient = {
      ...this.state.editingClient,
    };
    set(editingClient, e.target.name, e.target.value);
    this.setState({
      editingClient,
    });
  };

  handleInlineAddressUpdate = (e) => {
    let key = e.target.name;
    let val = e.target.value;
    const newPerson = {
      ...this.state.editingClient.person,
    };
    set(newPerson, key, val);
    this.setState({
      editingClient: {
        ...this.state.editingClient,
        person: merge({}, this.state.editingClient.person, newPerson),
      },
    });
  };

  handleModalUpdate = (clientDetails) => {
    analytics.track('Broker Portal - Update Client Submitted');
    this.props
      .updateClient(clientDetails)
      .then((client) => {
        analytics.track('Broker Portal - Update Client Succeeded');
        this.setState({
          editingClient: client,
        });
        this.updateClientModal.hide();
      })
      .catch((error) => {
        analytics.track('Broker Portal - Update Client Failed');
        this.props.onNotifyError(error);
      });
  };

  handleNextWithoutQuote = () => {
    const { broker, getPlans, onSubmit, createQuote, onNotifyError } =
      this.props;

    this.setState({
      isSubmitting: true,
    });

    const { editingClient } = this.state;
    const policyholder = {
      first_name: editingClient.person.first_name,
      last_name: editingClient.person.last_name,
      email: editingClient.person.email,
      phone_number: editingClient.person.phone_number,
      address: editingClient.person.address,
      position_on_policy: 1,
    };

    // XXX: Hardcoding country until Google Maps Autocomplete implemented
    if (editingClient.person.address) {
      editingClient.person.address.country = {
        code: 'US',
        name: 'United States',
      };
    }
    const createdQuote = {
      broker: broker,
      verticalCode: 'chubb_passport360',
      application: {
        client: { ...editingClient.person, client_type: 'individual' },
        holders: [policyholder],
        rating_address: editingClient.person.address,
      },
    };
    createQuote(createdQuote)
      .then((quote) => {
        return getPlans(quote.quote_number).then(onSubmit);
      })
      .catch((error) => {
        this.setState({
          isSubmitting: false,
        });
        onNotifyError(error);
      });
  };

  handleNext = () => {
    const {
      client,
      quote,
      getClient,
      getPlans,
      onSubmit,
      updateClient,
      updateQuote,
    } = this.props;
    const clientUpdatePromise = new Promise((resolve, reject) => {
      if (isEqual(this.state.editingClient, client)) {
        resolve(this.state.editingClient);
      } else {
        updateClient(this.state.editingClient).then(resolve, reject);
      }
    });

    this.setState({
      isSubmitting: true,
    });

    clientUpdatePromise
      .then(() => {
        return getClient(client.id);
      })
      .then((updatedClient) => {
        const policyholder = {
          ...updatedClient.person,
          position_on_policy: 1,
        };

        // XXX: Hardcoding country until Google Maps Autocomplete implemented
        if (updatedClient.person.address) {
          updatedClient.person.address.country = {
            code: 'US',
            name: 'United States',
          };
        }
        const updatedQuote = merge({}, quote, {
          application: {
            client: updatedClient.person,
            holders: [policyholder],
            rating_address: updatedClient.person.address,
          },
        });
        return updateQuote(updatedQuote);
      })
      .then((quote) => {
        return getPlans(quote.quote_number);
      })
      .then(onSubmit)
      .catch((error) => {
        this.setState({
          isSubmitting: false,
        });
        this.props.onNotifyError(error);
      });
  };

  showUpdateClientModal = (e) => {
    e.preventDefault();
    analytics.track('Broker Portal - Edit Client Modal Opened');
    this.updateClientModal.show();
  };

  get isNextDisabled() {
    const { editingClient, isSubmitting } = this.state;
    return (
      some(
        [
          get(editingClient, 'person.first_name'),
          get(editingClient, 'person.last_name'),
          get(editingClient, 'person.email'),
          get(editingClient, 'person.phone_number'),
          get(editingClient, 'person.address.line1'),
          get(editingClient, 'person.address.city'),
          get(editingClient, 'person.address.region.code'),
          get(editingClient, 'person.address.postal'),
        ],
        isEmpty
      ) || isSubmitting
    );
  }

  get title() {
    const { actor, isShareLinkFlow } = this.props;
    const { editingClient } = this.state;

    if (actor === 'broker' || isShareLinkFlow) {
      return 'Who are you enrolling in Passport 360?';
    } else {
      return `Welcome ${editingClient.person.first_name}! Please tell us about yourself:`;
    }
  }

  render() {
    const { client, isUpdatingClient, isShareLinkFlow } = this.props;
    const { editingClient } = this.state;

    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            <h3 className="text-center semi-bold">{this.title}</h3>
            {isShareLinkFlow ? (
              <ShareLinkDetails
                editingClient={editingClient}
                handleNewClientUpdate={this.handleNewClientUpdate}
                handlePhoneInit={this.handlePhoneInit}
                handleInlinePhoneUpdate={this.handleInlinePhoneUpdate}
                handleInlineAddressUpdate={this.handleInlineAddressUpdate}
              />
            ) : (
              <QuoteDetails
                client={client}
                editingClient={editingClient}
                showUpdateClientModal={this.showUpdateClientModal}
                handleNewClientUpdate={this.handleNewClientUpdate}
                handlePhoneInit={this.handlePhoneInit}
                handleInlinePhoneUpdate={this.handleInlinePhoneUpdate}
                handleInlineAddressUpdate={this.handleInlineAddressUpdate}
              />
            )}
            <div className="row justify-content-center">
              <button
                className="btn btn-lg btn-complete"
                disabled={this.isNextDisabled}
                onClick={
                  isShareLinkFlow
                    ? this.handleNextWithoutQuote
                    : this.handleNext
                }
              >
                Next
              </button>
            </div>
          </div>
        </div>
        <ModalClientDetails
          client={editingClient}
          isUpdatingClient={isUpdatingClient}
          onSubmit={this.handleModalUpdate}
          ref={(c) => (this.updateClientModal = c)}
        />
      </div>
    );
  }
}

Passport360EnrollmentPolicyholderView.propTypes = propTypes;

export default Passport360EnrollmentPolicyholderView;
